export class Vector {

  constructor(x? : number, y? : number, z? : number) {
    this.x = x || 0;
    this.y = y || 0;
    this.z = z || 0;
  }

  x = 0;
  y = 0;
  z = 0;
}
